





























































import Vue from 'vue'
import moment from 'moment'
import { TranslateResult } from 'vue-i18n'
import { PlanningAssistantPeriodicityPayload } from '@/types/payload'
import { CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY } from '@/store/action-types'
import {
  CALENDAR_EVENT_ASSISTANT_GET_END_DATE,
  CALENDAR_EVENT_ASSISTANT_GET_IS_EDITING_SERIE,
  CALENDAR_EVENT_ASSISTANT_GET_START_DATE,
  GET_SELECTED_UI_LANGUAGE
} from '@/store/getter-types'
import { CalendarEvent } from '@/model/planning/CalendarEvent'
import { CalendarEventSerie } from '@/types/service-response'

interface ComponentData {
  isUnique: boolean,
  weekDayList: Array<DayListItem>
  selectedWeekDayList: Array<number>

  repeatEveryNthWeek: number
  expireAfterRepetitions: number
  menu1: false,
  expireAfterDateIso: string | null
  expireAfterDateFormatted: string | null
  nullableDateRules: Function[]
}

interface DayListItem {
  number: number
  day: TranslateResult
}

export default Vue.extend({
  name: 'CalendarEventEditorPeriodicity',

  props: {
    step: String,
    editCalendarEvent: Object as () => CalendarEvent | undefined,
    editCalendarEventSerie: Object as () => CalendarEventSerie | undefined,
  },

  data (): ComponentData {
    return {
      isUnique: true,

      weekDayList: [
        {
          day: this.$t('planningPage.monday'),
          number: 1
        },
        {
          day: this.$t('planningPage.tuesday'),
          number: 2
        },
        {
          day: this.$t('planningPage.wednesday'),
          number: 3
        },
        {
          day: this.$t('planningPage.thursday'),
          number: 4
        },
        {
          day: this.$t('planningPage.friday'),
          number: 5
        },
        {
          day: this.$t('planningPage.saturday'),
          number: 6
        },
        {
          day: this.$t('planningPage.sunday'),
          number: 7
        },
      ],

      selectedWeekDayList: [],

      repeatEveryNthWeek: 1,
      expireAfterRepetitions: 0,
      menu1: false,
      expireAfterDateIso: null,
      expireAfterDateFormatted: null,
      nullableDateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        }
      ],
    }
  },

  computed: {
    isDisabled (): boolean {
      return this.isUnique || (this.selectedWeekDayList && this.selectedWeekDayList.length === 0)
    },

    isEdittingCalendarEvent (): boolean {
      return !!this.editCalendarEvent
    },

    isEdittingSerie (): boolean {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_IS_EDITING_SERIE]
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    isPeriodicityDisabled (): boolean {
      const dateStart: Date = this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_START_DATE]
      const dateEnd: Date = this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_END_DATE]

      if(moment(dateStart).format('DD:MM:YYYY') === moment(dateEnd).format('DD:MM:YYYY')) {
        return false
      } else {
        this.resetState()
        return true
      }

    }
  },

  watch: {
    isUnique (newVal: boolean): void {
      if (newVal) {
        this.resetState()
      }

      this.updateStoreValues()
    },

    selectedWeekDayList (newVal: Array<number>): void {
      if(newVal) {
        newVal.length > 0 ? this.isUnique = false : this.isUnique = true
      }
    },

    step (newVal: string): void {
      if(newVal && newVal === '2') {
        setTimeout(() => {
          const focusedCheck: any = document.getElementById('focusedCheck')
          if (focusedCheck) {
            focusedCheck.focus()
          }
        }, 300)
      }
    },

    expireAfterDateFormatted (newVal: string | null): void {
      if(newVal) {
        this.expireAfterDateIso = moment(newVal, 'DD.MM.YYYY').isValid() ?  moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
        this.onFieldValueChange()
      } else {
        this.expireAfterDateIso = null
        this.onFieldValueChange()
      }
    },
  },

  methods: {
    onFieldExpireAfterDateChange (date: string): void {
      this.expireAfterDateFormatted = moment(date).format('DD.MM.YYYY')
      this.onFieldValueChange()
    },

    onBlurExpireAfterDate (): void {
      this.expireAfterDateFormatted = this.expireAfterDateIso && moment(this.expireAfterDateIso).isValid() ? moment(this.expireAfterDateIso).format('DD.MM.YYYY') : null
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onFieldValueChange (): void {
      this.updateStoreValues()
    },

    updateStoreValues (): void {
      const payload: PlanningAssistantPeriodicityPayload = {
        isUnique: this.selectedWeekDayList && this.selectedWeekDayList.length > 0 ? false : true,
        weekDayList: this.selectedWeekDayList,
        repeatEveryNthWeek: this.repeatEveryNthWeek,
        expireAfterRepetitions: this.expireAfterRepetitions,
        expireAfterDate: this.expireAfterDateIso && moment(this.expireAfterDateIso).toDate() || undefined
      }

      this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY, payload)
    },

    resetState (): void {
      if(this.editCalendarEventSerie) {
        let days: Array<number> = []
        if(this.editCalendarEventSerie.Montag){
          days.push(1)
        }
        if(this.editCalendarEventSerie.Dienstag){
          days.push(2)
        }
        if(this.editCalendarEventSerie.Mittwoch){
          days.push(3)
        }
        if(this.editCalendarEventSerie.Donnerstag){
          days.push(4)
        }
        if(this.editCalendarEventSerie.Freitag){
          days.push(5)
        }
        if(this.editCalendarEventSerie.Samstag){
          days.push(6)
        }
        if(this.editCalendarEventSerie.Sonntag){
          days.push(7)
        }

        this.isUnique = this.editCalendarEventSerie.Einmalig
        this.selectedWeekDayList = days
        this.repeatEveryNthWeek = this.editCalendarEventSerie.Wiederholungs
        this.expireAfterRepetitions = this.editCalendarEventSerie.EndAfternTimes
        this.expireAfterDateIso = this.editCalendarEventSerie.EndAfterDate!
        this.expireAfterDateFormatted = this.expireAfterDateIso ? moment(this.expireAfterDateIso).format('DD.MM.YYYY') : null
      } else {
        this.isUnique = true
        this.selectedWeekDayList = []
        this.repeatEveryNthWeek = 1
        this.expireAfterRepetitions = 0
        this.expireAfterDateIso = null
        this.expireAfterDateFormatted = null
      }
    }
  },

  mounted (): void {
    this.resetState()
  }
})
